import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumb from "component/common/breadcrumb";
import strings from "translate/language";
import moment from "moment";

const AppointmentDetailsCp = () => {
  const location = useLocation();
  const appointmentState = location.state?.appointment;

  const [appointment, setAppointment] = useState(appointmentState || null);

  // Fallback: Load from localStorage if state is missing
  useEffect(() => {
    if (!appointmentState) {
      const stored = localStorage.getItem("appointment_cp");
      if (stored) {
        setAppointment(JSON.parse(stored));
      }
    } else {
      // Save to localStorage for refresh persistence
      localStorage.setItem("appointment_cp", JSON.stringify(appointmentState));
    }
  }, [appointmentState]);

  if (!appointment) {
    return <div className="text-center mt-5">No appointment details found.</div>;
  }

  const getStatus = (status) => {
    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "Confirmed";
      case 3:
        return "Complete";
      case 4:
        return "Appointment Cancelled";
      default:
        return "Unknown";
    }
  };

  const getCpType = (cpType) => {
    switch (cpType) {
      case 1:
        return "Justo CP";
      case 2:
        return "Other CP";
      case 3:
        return "Referral Partner";
      default:
        return "Unknown";
    }
  };

  const renderRow = (label, value) => (
    <>
      <div className="row py-1">
        <div className="col-md-3">
          <label>
            <strong>{label} :</strong>
          </label>
        </div>
        <div className="col-md-5">
          <label className="boldText">
            {value || strings.notavailable}
          </label>
        </div>
      </div>
      <hr />
    </>
  );

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.apptWithCp}
        titleactive={strings.appointmentDetails}
        url="/appointment_with_cp"
        parentListing={strings.appointmentListCP}
        isBackBtn={true}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.appointmentDetails}</h5>
              </div>
              <div className="card-body bg-white">
                {renderRow(
                  "Appointment Date & Time",
                  `${moment(appointment.appointment_date).format("YYYY-MM-DD")} & ${appointment.appointment_time}`
                )}
                {renderRow("Appointment Type", appointment.appointment_type_title)}
                {renderRow("CP Type", getCpType(appointment.registered_cp))}
                {renderRow("Appointment With", appointment.receiver_name)}
                {renderRow("Mobile Number", appointment.non_reg_cp_mobile)}
                {renderRow("Email Address", appointment.non_reg_cp_email)}
                {renderRow("Status", getStatus(appointment.appointment_status))}
                {renderRow("Property Name", appointment.property_title)}
                {appointment.remark && renderRow("Remark", appointment.remark)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentDetailsCp;
